import { render, staticRenderFns } from "./CookiesConsentSwitch.vue?vue&type=template&id=3dbb0a2a&scoped=true&"
import script from "./CookiesConsentSwitch.vue?vue&type=script&lang=js&"
export * from "./CookiesConsentSwitch.vue?vue&type=script&lang=js&"
import style0 from "./CookiesConsentSwitch.vue?vue&type=style&index=0&id=3dbb0a2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbb0a2a",
  null
  
)

export default component.exports